export default __webpack_public_path__ + "static/media/Film_thermo.376bcc1c.jpg";